import { render, staticRenderFns } from "./RegulationsModal.vue?vue&type=template&id=282e577e&scoped=true"
import script from "./RegulationsModal.vue?vue&type=script&lang=js"
export * from "./RegulationsModal.vue?vue&type=script&lang=js"
import style0 from "./RegulationsModal.vue?vue&type=style&index=0&id=282e577e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282e577e",
  null
  
)

export default component.exports